<template>
    <div
        class="g card"
        :class="[type? 'is-'+ type: '']"
    >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                required: false
            },
        },
    }
</script>

<style scoped lang="scss">

    .g.card::v-deep {
        @extend %grid-s;
        @extend %card;

        &.is-thin {
            padding: $interval-xs;
        }

        &.is-hover {
            @extend %card-hover;
            cursor: pointer;
        }

        > .md.caption {

            a {
                line-height: $btnInput_lh + $btnInput_pd * 2;
            }
        }
    }
</style>
